import React from 'react'
import { Fragment } from '.'
import { css } from '@emotion/css'

export function HighlightedText({
  fragments,
  renderHighlight
}: {
  readonly fragments: Fragment[]
  readonly renderHighlight?: (value: string, index: number) => React.ReactNode
}) {
  return (
    <React.Fragment>
      {fragments.map(({ match, value }, i) => {
        if (match) {
          return renderHighlight ? (
            renderHighlight(value, i)
          ) : (
            <span
              key={i}
              className={css`
                font-weight: 700;
              `}
              children={value}
            />
          )
        }
        return <span key={i} children={value} />
      })}
    </React.Fragment>
  )
}
